/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

export const EntityContext = createContext( {} );
EntityContext.displayName = 'EntityContext';
